import(/* webpackMode: "eager" */ "/opt/build/repo/apps/app/app/not-found.tsx");
